import { render } from "./TipoIden.vue?vue&type=template&id=970b351a&scoped=true"
import script from "./TipoIden.vue?vue&type=script&lang=js"
export * from "./TipoIden.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=970b351a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970b351a"]])

export default __exports__